import React, {Component} from 'react';
import './App.css';
import 'bootstrap/dist/css/bootstrap.css';
import './Jumbotron.css';
import {Button} from 'reactstrap';
import firebase, {auth, provider} from './firebase.js';
import {BrowserRouter as Router, Route, Link, Switch} from "react-router-dom";
import Home from './Home';
import About from './About';
import ReactGA from 'react-ga';
ReactGA.initialize('UA-116313297-1');



class App extends Component {
    constructor() {
        super();
        this.state = {
            user: {}
        };

        this.login = this.login.bind(this);
        this.logout = this.logout.bind(this);
    }

    login() {
        auth.signInWithPopup(provider)
            .then((result) => {
                const user = result.user;
                this.setState({
                    user
                });
            });
    }

    logout() {
        let self = this;
        console.log('logout');
        auth.signOut()
            .then(() => {
                self.setState({
                    user: {}
                });
            });
    }

    componentDidMount() {
        auth.onAuthStateChanged((user) => {
            if (user) {
                console.log("user", user);
                this.setState({user});
            }
        });
    }

    render() {

        const logPageView = () => {
            ReactGA.set({ page: window.location.pathname });
            ReactGA.pageview(window.location.pathname);
            return null;
        };

        return (
            <div className="App">
                <main role="main">
                    <Route path="/" component={logPageView} />

                    <Switch>
                        <Route exact path='/' render={() => (
                            <Home user={this.state.user} login={this.login} logout={this.logout}></Home>
                        )}/>
                        <Route path="/about" component={About}/>
                        {/*<Route path="*" component={() => (<div>NoMatch</div>)}/>*/}
                        {/*<Route path='/about' component={About}/>*/}
                    </Switch>
                </main>

                <footer className="text-muted">
                    <div className="container">
                        <p className="float-right">
                            <a href="#">Back to top</a><br/>
                            <Link to="/">Home</Link><br/>
                            <Link to="/about">About</Link>
                        </p>
                    </div>
                </footer>

            </div>
        );
    }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js